import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import { useGeneralSettings } from "@/Providers/General";
import { AdminInfluencerTable } from "./AdminInfluencerTable";
import { AdminBrandTable } from "./AdminBrandTable";
import { SidebarTrigger } from "@/shadcnComponents/ui/sidebar";

const host: string = import.meta.env.VITE_BACKEND_SERVER_URL;
export const AdminInfluencer = ({ userType }) => {
  const [, , removeCookie] = useCookies();
  const [allcreators, setallcreators] = useState([]);
  const [allBrands, setallBrands] = useState([]);
  const generalState = useGeneralSettings();

  const getBrandjwt = async (id, status) => {
    localStorage.removeItem("jwtToken");
    localStorage.removeItem("UserType");
    const response = await fetch(`${host}/developer/getBrandJwt`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": "true",
        jwtToken: localStorage.getItem("jwtTokenD"),
      },
      body: JSON.stringify({ id: id, status: status }),
    });
    const json = await response.json();
    if (json.success) {
      localStorage.setItem("jwtToken", json.jwtToken);
      localStorage.setItem("UserType", "Brand");
      localStorage.setItem("from", "developer");
    }
  };
  const getjwt = async (id, status) => {
    localStorage.removeItem("jwtToken");
    localStorage.removeItem("UserType");
    const response = await fetch(`${host}/developer/getCreatorJwt`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": "true",
        jwtToken: localStorage.getItem("jwtTokenD"),
      },
      body: JSON.stringify({ id: id, status: status }),
    });
    const json = await response.json();
    if (json.success) {
      localStorage.setItem("jwtToken", json.jwtToken);
      localStorage.setItem("UserType", "Influencer");
      localStorage.setItem("from", "developer");
    }
  };

  const handleClick = async (id, status) => {
    await getjwt(id, status).then(() => {
      window.open("/influencer/dashboard");
    });
  };

  const handleLogout = () => {
    localStorage.removeItem("jwtTokenD");
    localStorage.removeItem("jwtToken");
    localStorage.removeItem("isUser");
    localStorage.removeItem("isDev");
    localStorage.removeItem("c_id");
    removeCookie("devsession");
  };

  const handleBrandClick = async (id, status) => {
    await getBrandjwt(id, status).then(() => {
      window.open("/brand/dashboard");
    });
  };

  useEffect(() => {
    if (userType === "Influencer") {
      const allcreators = async () => {
        generalState?.setLoading(true);
        const response = await fetch(`${host}/developer/getallCreator`, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Access-Control-Allow-Credentials": "true",
            jwtToken: localStorage.getItem("jwtTokenD"),
          },
        });
        const json = await response.json();

        if (json.success) {
          generalState?.setLoading(false);
          setallcreators(json.creators);
        } else {
          generalState?.setLoading(false);
          toast.error("You are not allowed to Access", { autoClose: 1500 });
          handleLogout();
          window.open("/developer/login", "_self");
        }
      };
      allcreators();
    }
    if (userType === "Brand") {
      const allBrands = async () => {
        generalState?.setLoading(true);
        const response = await fetch(`${host}/developer/getallBrands`, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Access-Control-Allow-Credentials": "true",
            jwtToken: localStorage.getItem("jwtTokenD"),
          },
        });
        const json = await response.json();

        if (json.success) {
          generalState?.setLoading(false);
          setallBrands(json.creators);
        } else {
          generalState?.setLoading(false);
          toast.error("You are not allowed to Access", { autoClose: 1500 });
          handleLogout();
          window.open("/developer/login", "_self");
        }
      };
      allBrands();
    }
  }, [userType]);

  return (
    <div className="flex-col flex w-full h-full gap-6 ">
      <header className="flex h-16 shrink-0 items-center gap-2 border-b px-6">
        <SidebarTrigger />
        <h1 className="text-2xl font-bold">
          All {userType === "Influencer" ? `Influencers` : `Brands`}
        </h1>
      </header>
      <div className="w-full flex flex-col items-center gap-[20px] font-inter ">
        <span className="font-bold ">
          Total Number of {userType === "Influencer" ? `influencers` : `Brands`}{" "}
          : {userType === "Influencer" ? allcreators?.length : allBrands.length}{" "}
        </span>
        <div className=" w-full flex flex-wrap justify-center gap-[20px]">
          {allcreators.length !== 0 && userType === "Influencer" ? (
            <>
              <AdminInfluencerTable
                allcreators={allcreators}
                handleClick={handleClick}
              />
            </>
          ) : (
            ""
          )}
          {allBrands.length !== 0 && userType === "Brand" ? (
            <AdminBrandTable
              allBrands={allBrands}
              handleBrandClick={handleBrandClick}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};
